import {getId} from 'apis/model/base'
import {createValue} from 'components/form/utils'
import React from 'react'
import ContainerPicker from 'views/AppLocals/custom/ContainerPicker'
import {AppEntities} from 'views/AppLocals/enums'
import {NullAsDefault} from 'views/Shared'
import {InnerWrapper, renderBaseOption} from '../../../../components/selectors/BaseSelector'
import useTranslate from "../../../../modules/local/useTranslate";
import {timetable_getDetails_Api} from "../../../../apis";
import getTitle from "../../../../helpers/getTitle";
import {DoubleValueItem} from 'components/common/DoubleValueItem'
import {renderFromToTime} from "../../../../helpers/datetimeHelpers";
import classNames from "classnames";
import {renderIfElse} from "../../../Shared";
import dayjs from "dayjs";
import {GoDotFill} from "react-icons/go";
import Pure from "../../../../components/Pure";

export const CourseClassTimetableDetailSelector = ({
                                                       name,
                                                       value,
                                                       subject_id,
                                                       course_class_id,
                                                       course_class_timetable_detail_id,
                                                       onChange = NullAsDefault,
                                                       ...props
                                                   }) => {
    const t = useTranslate();
    const defaultValue = getId(value) ?? value
    return (
        <Pure input={[defaultValue, subject_id, course_class_id, course_class_timetable_detail_id]}>
            <ContainerPicker
                name={name}
                allowClear={true}
                defaultValue={defaultValue}
                type={AppEntities.UNDEFINED}
                placeholder="click to select"
                renderInnerWrapper={InnerWrapper}
                getOption={(option) => option}
                renderOption={renderBaseOption(defaultValue, (option) => {
                    const {subject, start_time, end_time, location_address} = option ?? {}
                    const time = renderFromToTime(start_time, end_time)

                    // 3 trạng thái theo lịch: ngày đã qua (mờ) · hôm nay (sáng xanh, mờ nhẹ nếu quá
                    // giờ kết thúc) · tương lai (bình thường). Thiếu end_time -> mặc định 23:59 hôm đó.
                    const now = dayjs()
                    const start = dayjs(start_time)
                    const end = end_time ? dayjs(end_time) : start.endOf('day')
                    const isPastDay = start.isBefore(now, 'day')
                    const isToday = start.isSame(now, 'day')
                    const isOngoing = isToday && now.isAfter(start) && now.isBefore(end)
                    const isTodayEnded = isToday && now.isAfter(end)

                    return ({
                        title: isToday ? (
                            <span className={classNames(
                                "flex w-full items-center justify-between gap-1.5 min-w-0 font-medium text-blue-600",
                                isTodayEnded && "opacity-60"
                            )}>
                                <span className="truncate">{getTitle(subject)}</span>
                                <span className="flex-shrink-0 inline-flex items-center gap-1 px-1.5 rounded-full bg-blue-50 border border-blue-200 text-2xs font-semibold whitespace-no-wrap">
                                    {t('today schedule')}
                                    {isOngoing && (
                                        <>
                                            <GoDotFill size={6}/>
                                            {t('ongoing')}
                                        </>
                                    )}
                                </span>
                            </span>
                        ) : (
                            renderIfElse(
                                isPastDay,
                                <span className="font-medium text-color-300 opacity-40">
                                    {getTitle(subject)}
                                </span>,
                                getTitle(subject)
                            )
                        ),
                        description: (
                            <DoubleValueItem
                                labelFirst="time"
                                valueFirst={time}
                                labelSecond="in"
                                valueSecond={location_address}
                                className={classNames(
                                    "text-xs italic",
                                    isPastDay && 'opacity-50',
                                    isToday && !isTodayEnded && 'text-blue-500',
                                    isTodayEnded && 'opacity-60'
                                )}
                                style={{marginTop: 2}}
                            />
                        ),
                    })
                })}
                onOptionChange={(option) => {
                    onChange(createValue(name, option ?? null))
                }}
                customConfigs={{
                    refreshKey: [subject_id, course_class_id, course_class_timetable_detail_id].join("-"),
                    values: {subject_id, course_class_timetable_detail_id, owner_type: 'course_class', owner_id: course_class_id},
                    apiInfo: timetable_getDetails_Api,
                }}
                {...props}
            />
        </Pure>
    )
}
